import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { useI18n } from '../locales';

const useStyles = makeStyles()({
	root: {
		position: 'absolute',
		background: 
		'white',
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		zIndex: 2
	}
})

interface Props {
	email: string
}

export function AuthForgotPasswordFormSuccess(props: Props) {
	const { classes } = useStyles();
	const { t, Trans } = useI18n();
	return (
		<Box sx={{
			position: 'absolute',
			background: 'white',
			top: 0,
			left: 0,
			bottom: 0,
			right: 0,
			zIndex: 2,
			textAlign: 'center',
			boxSizing: 'border-box',
			pb: 1
		}}>
			<Typography
				display='block'
				fontSize={14}
				mb={2}
				textAlign='center'
			>
				<Trans
					i18nKey="We have sent an email with futher instructions to <0>{{email}}</0>"
					components={[
						<Typography
							color='primary'
							fontSize='inherit'
							display='inline'
						/>
					]}
					values={{ email: props.email }}
				/>.{' '}
				{t("If you don't receive any email, please check that email address you entered is correct")}
			</Typography>
		</Box>
	);
}
